import { useState } from 'react'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { Wrapper } from './styles'
import clock from 'assets/icons/clock.svg'
import { useIntl } from 'react-intl'
import OpeningHoursModal from 'components/global/OpeningHoursModal'
import Icon from 'components/shared/Icon'

const CheckOpeningHours = () => {
    const [isModalOpen, setIsModalOpen] = useState(false)
    const { formatMessage } = useIntl()

    return (
        <>
            <Wrapper
                direction="row"
                gap={16}
                padding={[16, 24]}
                align={['flex-start', 'center']}
            >
                <img src={clock} alt="clock icon" />
                <Box
                    direction={['column', 'row']}
                    isFullWidth
                    justify={['flex-start', 'space-between']}
                    align={['flex-start', 'center']}
                >
                    <Text variant="heading5" color="grayscale_900" mb={[8, 0]}>
                        {formatMessage({
                            id: 'global.msg.check_opening_hours',
                            defaultMessage:
                                'Przed wizytą w parku sprawdź godziny otwarcia',
                        })}
                    </Text>
                    <Box
                        as="button"
                        direction="row"
                        onClick={() => setIsModalOpen(true)}
                        data-testid="ticket-button-show-opening-hours"
                        tabIndex={-1}
                    >
                        <Text
                            variant="bodyStrong"
                            color="secondary_500"
                            mr={12}
                        >
                            {formatMessage({
                                id: 'global.btn.opening_hours',
                                defaultMessage: 'Godziny otwarcia',
                            })}
                        </Text>
                        <Icon variant="arrow" />
                    </Box>
                </Box>
            </Wrapper>
            <OpeningHoursModal
                isOpened={isModalOpen}
                close={() => setIsModalOpen(false)}
            />
        </>
    )
}

export default CheckOpeningHours
